import { render, staticRenderFns } from "./stratejikplandegerlendirmetablosu.vue?vue&type=template&id=a7fffc10"
import script from "./stratejikplandegerlendirmetablosu.vue?vue&type=script&lang=js"
export * from "./stratejikplandegerlendirmetablosu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports